import { Component } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthService } from 'src/app/shared/service/auth.service';
import { bootstrapBell, bootstrapCircleFill } from '@ng-icons/bootstrap-icons';
import { ionLogOutOutline, ionPersonOutline } from '@ng-icons/ionicons';
import { ToastService } from 'src/app/shared/service/toast.service';
import { finalize } from 'rxjs';
import { LoadingButtonComponent } from 'src/app/shared/component/loading-button/loading-button.component';
import { handleApiError } from 'src/app/shared/util/handle-api-error';

@Component({
  selector: 'app-header',
  imports: [NgIcon, CommonModule, LoadingButtonComponent],
  templateUrl: './header.component.html',
  viewProviders: [
    provideIcons({
      bootstrapBell,
      ionLogOutOutline,
      ionPersonOutline,
      bootstrapCircleFill,
    }),
  ],
})
export class HeaderComponent {
  confirmLogoutOpen: boolean = false;
  loadingLogout: boolean = false;

  constructor(
    private authService: AuthService,
    private toastService: ToastService,
    private router: Router
  ) {}

  openConfirmLogout(): void {
    this.confirmLogoutOpen = true;
  }

  closeConfirmLogout(): void {
    this.confirmLogoutOpen = false;
  }

  confirmLogout(): void {
    this.loadingLogout = true;
    this.authService
      .logout()
      .pipe(
        handleApiError(this.toastService, 'Error al cerrar sesión'),
        finalize(() => {
          this.loadingLogout = false;
          this.confirmLogoutOpen = false;
        })
      )
      .subscribe({
        next: () => {
          this.router.navigate(['/admin/login']);
        },
      });
  }
}
